/** @typedef {import('@utahdts/utah-design-system').AriaLiveType} AriaLiveType */

/** @enum {AriaLiveType} */
export const ariaLiveTypes = {
  ASSERTIVE: /** @type {AriaLiveType} */ ('assertive'),
  POLITE: /** @type {AriaLiveType} */ ('polite'),
};
